module.exports = __webpack_public_path__ + "img/l.8149c7da.jpg";